export default __webpack_public_path__ + "static/media/unattemptedIcon.48c6c057.svg";